// 封装oss方法
import OSS from 'ali-oss';

export default function Client(data) {
    const client = new OSS ({
        region: data.region, // "填写Bucket所在的区域，例如：oss-cn-guangzhou",
        accessKeyId: data.accessKeyId, // "填写通过阿里云控制台创建的AccessKeyID",
        accessKeySecret: data.accessKeySecret, //"填写通过阿里云控制台创建的AccessKeySecret",
        stsToken: data.stsToken,
        bucket: data.bucket, // "通过控制台或PutBucket创建的Bucket"
    })
    return client
}